import React, { useEffect, useState } from 'react';
import { Box, Chip, IconButton, Tooltip, Badge } from '@mui/material'
import UpIcon from '@mui/icons-material/VerticalAlignTop';
import DownIcon from '@mui/icons-material/VerticalAlignBottom';
import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIconIcon from '@mui/icons-material/Delete';
import SettingsIcon from '@mui/icons-material/Settings';
import DownloadIcon from '@mui/icons-material/Archive';
import AddIcon from '@mui/icons-material/AddCircle';
import FilterIcon from '@mui/icons-material/FilterList';
import RefreshIcon from '@mui/icons-material/Autorenew';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Search from '../Search/Search';
import { Trans } from '../Translate';
import ColumnConfigs from './ColumnConfigs';

export default function Toolbar(props) {
    const {
        onSearch,
        onReorder,
        onRefreshClick,
        onExportClick,
        onFilterClick,
        onSettingClick,
        onAddClick,
        onCustomButtonClick,
        customButtonLabel,
        customButtonIcon,
        selectedRows,
        onEditClick,
        onDeleteClick,
        disableReorderUp,
        disableReorderDown,
        deleteIcon,
        selectedFilters,
        removeFilter,
        addLabel, editLabel, deleteLabel,
        onExportPdfClick,
        searchText,
        customComponentForSelectedRows,
        selectedRowsList,
        exportLabel,
        id,
        columns,
        loadConfigColumns,
        enableColumnConfigs
    } = props;

    const [openSearch, setOpenSearch] = useState(false);

    useEffect(() => {
        if (!!searchText && openSearch === false) {
            setOpenSearch(true);
        }
    }, [searchText]);

    var timerSearchText = null;

    function openSeach() {
        setOpenSearch(true);
    }

    function closeSeach() {
        setOpenSearch(false);
        onChangeSearchHandle("");
    }

    function onChangeSearchHandle(value) {
        window.clearTimeout(timerSearchText);
        timerSearchText = window.setTimeout(() => {
            if (typeof onSearch === 'function') {
                onSearch(value);
            }
        }, 600);
    }

    return (
        <>
            {selectedFilters && selectedFilters.length > 0 && typeof removeFilter === 'function' && <Box marginRight={2}>
                {selectedFilters.map((filter) => <Chip
                    label={filter.label}
                    color="primary"
                    onDelete={() => removeFilter(filter.key)}
                    style={{ fontSize: 12, marginLeft: 3 }}
                    size="small"
                    key={filter.key}
                />)}
            </Box>}
            {typeof onSearch === 'function' &&
                <>
                    {openSearch ?
                        <Search searchText={searchText} handleOnChange={onChangeSearchHandle} onCancel={closeSeach} />
                    :
                        <Tooltip title={<Trans translateKey="search" capitalize />}>
                            <IconButton
                                size='small'
                                onClick={openSeach} color="inherit">
                                <SearchIcon />
                            </IconButton>
                        </Tooltip>
                    }
                </>
            }

            {(selectedRows.length === 1 && typeof onReorder === 'function') &&
                <>
                    {!disableReorderUp && <Tooltip title={<Trans translateKey="upItem" capitalize />}>
                        <IconButton
                            size='small'
                            onClick={() => onReorder(-1)} color="inherit">
                            <UpIcon />
                        </IconButton>
                    </Tooltip>}
                    {!disableReorderDown && <Tooltip title={<Trans translateKey="downItem" capitalize />}>
                        <IconButton
                            size='small'
                            onClick={() => onReorder(1)} color="inherit">
                            <DownIcon />
                        </IconButton>
                    </Tooltip>}
                </>
            }

            {typeof onExportClick === 'function' &&
                <Tooltip title={exportLabel ? exportLabel : 'Exportar'}>
                    <IconButton
                        size='small'
                        onClick={onExportClick} color="inherit">
                        <DownloadIcon />
                    </IconButton>
                </Tooltip>
            }

            {(selectedRows.length > 0 && typeof onExportPdfClick === 'function') &&
                <Tooltip title={'Exportar PDF'}>
                    <IconButton
                        size='small'
                        onClick={onExportPdfClick} color="inherit">
                        <PictureAsPdfIcon />
                    </IconButton>
                </Tooltip>
            }

            {typeof onFilterClick === 'function' &&
                <Tooltip title={'Filtros'}>
                    <IconButton
                        size='small'
                        onClick={onFilterClick} color="inherit">
                        <Badge
                            badgeContent={(selectedFilters && selectedFilters.length) ? selectedFilters.length : 0}
                            color="error"
                            invisible={!(selectedFilters && selectedFilters.length > 0)}
                            overlap="circular"
                            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                            sx={{
                                '& .MuiBadge-badge': {
                                    fontSize: '0.7rem',
                                    fontWeight: 600,
                                    minWidth: 18,
                                    height: 18,
                                    borderRadius: '9px',
                                }
                            }}
                        >
                            <FilterIcon />
                        </Badge>
                    </IconButton>
                </Tooltip>
            }

            {typeof onSettingClick === 'function' &&
                <Tooltip title={'Configurar'}>
                    <IconButton
                        size='small'
                        onClick={onSettingClick} color="inherit">
                        <SettingsIcon />
                    </IconButton>
                </Tooltip>
            }

            {typeof onCustomButtonClick === 'function' &&
                <Tooltip title={customButtonLabel}>
                    <IconButton
                        size='small'
                        onClick={onCustomButtonClick} color="inherit">
                        {customButtonIcon}
                    </IconButton>
                </Tooltip>
            }

            {typeof onAddClick === 'function' &&
                <Tooltip title={addLabel || <Trans translateKey="add" capitalize />}>
                    <IconButton
                        size='small'
                        onClick={onAddClick} color="inherit">
                        <AddIcon />
                    </IconButton>
                </Tooltip>
            }

            {(selectedRows.length === 1 && typeof onEditClick === 'function') &&
                <Tooltip title={editLabel || <Trans translateKey="edit" capitalize />}>
                    <IconButton
                        size='small'
                        onClick={onEditClick} color="inherit">
                        <EditIcon />
                    </IconButton>
                </Tooltip>
            }

            {(selectedRows.length > 0 && typeof onDeleteClick === 'function') &&
                <Tooltip title={deleteLabel || <Trans translateKey="delete" capitalize />}>
                    <IconButton
                        size='small'
                        onClick={onDeleteClick} color="inherit">
                        {deleteIcon || <DeleteIconIcon />}
                    </IconButton>
                </Tooltip>
            }

            {typeof onRefreshClick === 'function' &&
                <Tooltip title={<Trans translateKey="refresh" capitalize />}>
                    <IconButton
                        size='small'
                        onClick={onRefreshClick} color="inherit">
                        <RefreshIcon />
                    </IconButton>
                </Tooltip>
            }

            {(!!id && enableColumnConfigs) && <ColumnConfigs id={id} columns={columns} loadConfigColumns={loadConfigColumns} />}

            {customComponentForSelectedRows && customComponentForSelectedRows({ selectedRows: selectedRowsList, refresh: onRefreshClick })}

        </>
    )
}